import { ITableRenderCell } from 'CorePackage/TableModule/interfaces/ITableRenderCell';
import { IKnmRaw } from 'KnmListPackage/MainModule/interfaces/IKnmRaw';

export const KnmListByPlanTotalDurationCell = ({ value }: ITableRenderCell<IKnmRaw>) => {
  if (!value || typeof value !== 'object' || !('durationHours' in value)) {
    return null;
  }

  const { durationHours } = value;

  return <div>{durationHours}</div>;
};
